import serverData from '../utils/server-data'
import { groupApi } from './groupApi'

export interface UpdatePhotoPayload {
  id: string
  backgroundImageUrl: string
}

export const updatePhotoApiSlice = groupApi.injectEndpoints({
  endpoints: (builder) => ({
    updatePhoto: builder.mutation<
      { backgroundImageUrl: string },
      UpdatePhotoPayload
    >({
      query: ({ id, ...body }) => ({
        url: `/${id}/set-photo`,
        headers: { 'X-CSRF-Token': serverData._csrf },
        method: 'PUT',
        body,
      }),
      async onQueryStarted({ id, ...body }, { dispatch, queryFulfilled }) {
        const putResult = dispatch(
          groupApi.util.updateQueryData(
            'getGroupDetail',
            id,
            (groupToUpdate) => {
              groupToUpdate.customer.moneyPools.moneyPool.backgroundImageUrl =
                body.backgroundImageUrl
            },
          ),
        )

        try {
          await queryFulfilled
        } catch {
          putResult.undo()
        }
      },
      invalidatesTags: (_result, error, arg) =>
        error ? [] : [{ type: 'groupDetail', id: arg.id }],
    }),
  }),
})

export const { useUpdatePhotoMutation } = updatePhotoApiSlice
